import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 49.7 95",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsx("path", { d: "M6.5,0C2.9,0,0,2.9,0,6.5v82c0,3.6,2.9,6.5,6.5,6.5h36.7c3.6,0,6.5-2.9,6.5-6.5V6.5c0-3.6-2.9-6.5-6.5-6.5H6.5ZM18.4,4.3h13c.6,0,1.1.5,1.1,1.1s-.5,1.1-1.1,1.1h-13c-.6,0-1.1-.5-1.1-1.1s.5-1.1,1.1-1.1ZM4.4,10.8h41v69.1H4.4V10.8ZM24.9,83.1c2.4,0,4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3-4.3-1.9-4.3-4.3,1.9-4.3,4.3-4.3Z" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 4.4,
			y: 10.8,
			width: 41,
			height: 69.1
		})
	]
});
export default SvgPhone;
